import { useMemo } from "react";

import { useListModels } from "./useListModels";

export const useModel = (modelId: string) => {
  const { models, loadingModels } = useListModels();

  const model = useMemo(() => {
    return models.find((m) => m.id === modelId);
  }, [models, modelId]);
  return { model, loading: loadingModels };
};
